import { keyframes, css } from "styled-components";

/**
 * Source:
 *   https://github.com/daneden/animate.css/blob/da9afc06e8aa563baae6f406a0a844999ccc066b/source/zooming_entrances/zoomIn.css
 */
export const zoomIn = keyframes`
  from {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }

  50% {
    opacity: 1;
  }
`;

/**
 * Source:
 *   https://github.com/daneden/animate.css/blob/6155392f49bf7087ef9525a4b5390c7d24c71e67/source/fading_entrances/fadeIn.css
 */
const fadeIn = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

export const fadeInRule = css`
  ${fadeIn} 1s;
`;
